import { render, staticRenderFns } from "./TenantSelection.vue?vue&type=template&id=7c4987b2&"
import script from "./TenantSelection.vue?vue&type=script&lang=js&"
export * from "./TenantSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports